export class PriceComponentsBracket {
  base: number = null;
  priceComponentId: number = null;
  sequence: number;
}
